import React from 'react';
import './VerificationBadge.css';

/**
 * Reusable VerificationBadge component
 * Shows Verified / Inspected / Certified badge based on verificationLevel
 * 
 * @param {string} level - 'verified', 'inspected', 'certified', 'pending', or null
 * @param {string} size - 'sm', 'md', 'lg' (default: 'sm')
 * @param {boolean} showLabel - show text label (default: true)
 * @param {boolean} showIcon - show icon (default: true)
 */
const VerificationBadge = ({ level, size = 'sm', showLabel = true, showIcon = true }) => {
  if (!level || level === 'pending' || level === 'declined' || level === 'none') {
    return null;
  }

  const config = {
    verified: {
      label: 'Verified',
      color: '#1E40AF',
      bg: '#DBEAFE',
      icon: (
        <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
          <path d="M17.5 6.875L8.125 16.25L3.75 11.875" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    inspected: {
      label: 'Inspected',
      color: '#92400E',
      bg: '#FEF3C7',
      icon: (
        <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
          <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M17.5 17.5L13.875 13.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7.08333 9.16667L8.75 10.8333L11.6667 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    },
    certified: {
      label: 'Certified',
      color: '#166534',
      bg: '#DCFCE7',
      icon: (
        <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
          <path d="M10 1.25L2.5 5V11.25C2.5 16.25 5.83333 19.5833 10 20.8333C14.1667 19.5833 17.5 16.25 17.5 11.25V5L10 1.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M7.5 10L9.16667 11.6667L12.5 8.33333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  };

  const badgeConfig = config[level];
  if (!badgeConfig) return null;

  return (
    <span 
      className={`verification-badge-tag vb-${level} vb-size-${size}`}
      style={{ color: badgeConfig.color, backgroundColor: badgeConfig.bg }}
    >
      {showIcon && <span className="vb-icon">{badgeConfig.icon}</span>}
      {showLabel && <span className="vb-label">{badgeConfig.label}</span>}
    </span>
  );
};

export default VerificationBadge;
